import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    isPendingAction,
    isRejectedAction,
    isFullfieldAction
} from "./slice.helper";

import Api from "../../services/vente-privee.service";


// =====================================================
// Vente Privée CRUD
// =====================================================

export const listVentePrivee = createAsyncThunk(
    "VentePrivee/list",
    async (_, { rejectWithValue }) => {
        try {
            const res = await Api.listVp();
            return res.data;
        } catch (error) {
            const message =
                (error.response?.data?.message) ||
                error.message ||
                error.toString();
            return rejectWithValue(message);
        }
    }
);

export const createVentePrivee = createAsyncThunk(
    "VentePrivee/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createVp(data);
            return res.data;
        } catch (error) {
            const message =
                (error.response?.data?.message) ||
                error.message ||
                error.toString();
            return rejectWithValue(message);
        }
    }
);

export const updateVentePrivee = createAsyncThunk(
    "VentePrivee/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.updateVp(id, data);
            return res.data;
        } catch (error) {
            const message =
                (error.response?.data?.message) ||
                error.message ||
                error.toString();
            return rejectWithValue(message);
        }
    }
);

export const deleteVentePrivee = createAsyncThunk(
    "VentePrivee/delete",
    async (id, { rejectWithValue }) => {
        try {
            const res = await Api.removeVp(id);
            return res.data;
        } catch (error) {
            const message =
                (error.response?.data?.message) ||
                error.message ||
                error.toString();
            return rejectWithValue(message);
        }
    }
);


// =====================================================
// Campaign Source
// =====================================================

export const listVpCompagneSource = createAsyncThunk(
    "VentePrivee/listCompagneSource",
    async (vpId, { rejectWithValue }) => {
        try {
            const res = await Api.listVpCompagneSource(vpId);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const createVpCompagneSource = createAsyncThunk(
    "VentePrivee/createCompagneSource",
    async ({ vpId, data }, { rejectWithValue }) => {
        try {
            const res = await Api.createVpCompagneSource(vpId, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const updateVpCompagneSource = createAsyncThunk(
    "VentePrivee/updateCompagneSource",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.updateVpCompagneSource(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const deleteVpCompagneSource = createAsyncThunk(
    "VentePrivee/deleteCompagneSource",
    async (id, { rejectWithValue }) => {
        try {
            const res = await Api.deleteVpCompagneSource(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


// =====================================================
// Prospect
// =====================================================

export const listVpProspects = createAsyncThunk(
    "VentePrivee/listProspects",
    async ({ vpId, params }, { rejectWithValue }) => {
        try {
            const res = await Api.listVpProspects(vpId, params);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);
export const getVpProspectsCountByHour = createAsyncThunk(
    "VentePrivee/getVpProspectsCountByHour",
    async ({ vpId, date }, { rejectWithValue }) => {
        try {
            const res = await Api.getVpProspectsCountByHour(vpId, date);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const createVpProspect = createAsyncThunk(
    "VentePrivee/updateProspect",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.createVpProspect(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const updateVpProspect = createAsyncThunk(
    "VentePrivee/updateProspect",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.updateVpProspect(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const deleteVpProspect = createAsyncThunk(
    "VentePrivee/deleteProspect",
    async (id, { rejectWithValue }) => {
        try {
            const res = await Api.deleteVpProspect(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const confirmerVpRdv = createAsyncThunk(
    "VentePrivee/confirmerRdv",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.confirmerVpRdv(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const updateVpProspectStatus = createAsyncThunk(
    "VentePrivee/updateProspectStatus",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Api.updateVpProspectStatus(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const sendVpProspectRdvConfirmarionWsp = createAsyncThunk(
    "VentePrivee/sendRdvConfirmarionWsp",
    async (id, { rejectWithValue }) => {
        try {
            const res = await Api.sendRdvConfirmarionWsp(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);
export const getVpProspectById = createAsyncThunk(
    "VentePrivee/getVpProspect",
    async (id, { rejectWithValue }) => {
        try {
            const res = await Api.getVpProspect(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


// =====================================================
// Slice
// =====================================================

const initialState = {
    loading: false,
    error: "",
    sel_VentePrivee: null
};

const VentePriveeSlice = createSlice({
    name: "VentePrivee",
    initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState);
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = "fulfilled";
                state.loading = false;
                state.error = "";
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = "pending";
                state.loading = true;
                state.error = "";
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = "rejected";
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clear } = VentePriveeSlice.actions;
export default VentePriveeSlice.reducer;